/* ============================================================
   Wicked Clothes — Drawer Coordinator

   Mobile/desktop bug: the mobile menu, search overlay, and cart
   drawer could all be open simultaneously. This script enforces
   mutual exclusion: opening any one of the three force-closes
   the other two.

   Watches three openers:
     1. <header-drawer><details>      — mobile hamburger menu
     2. <details-modal><details>      — search modal/overlay
     3. <cart-drawer>                  — cart slide-in (uses .active class)

   Triggers:
     - For the two <details>-based drawers, listens for 'toggle' event
     - For cart-drawer (custom element), uses MutationObserver on the
       'class' attribute since it opens via .active class
   ============================================================ */
(function () {
  'use strict';

  function getMenu()   { return document.querySelector('header-drawer details, menu-drawer details'); }
  function getSearch() { return document.querySelector('details-modal details'); }
  function getCart()   { return document.querySelector('cart-drawer'); }

  function closeMenu() {
    var d = getMenu();
    if (d && d.hasAttribute('open')) d.removeAttribute('open');
  }

  function closeSearch() {
    var d = getSearch();
    if (d && d.hasAttribute('open')) d.removeAttribute('open');
  }

  function closeCart() {
    var c = getCart();
    if (!c || !c.classList.contains('active')) return;
    if (typeof c.close === 'function') {
      c.close();
    } else {
      c.classList.remove('active');
    }
  }

  function init() {
    var menu = getMenu();
    var search = getSearch();
    var cart = getCart();

    /* Menu drawer — close the other two when it opens */
    if (menu) {
      menu.addEventListener('toggle', function () {
        if (menu.open) { closeSearch(); closeCart(); }
      });
    }

    /* Search overlay — close the other two when it opens */
    if (search) {
      search.addEventListener('toggle', function () {
        if (search.open) { closeMenu(); closeCart(); }
      });
    }

    /* Cart drawer — class-based open. Watch for .active being added.
       Handles both icon-click opens AND programmatic opens (quick-add,
       cart-notification → "view cart", etc.). */
    if (cart && typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        if (cart.classList.contains('active')) {
          closeMenu();
          closeSearch();
        }
      }).observe(cart, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
